export default "__VITE_ASSET__Bdxm5b6m__"